import React, { useEffect } from "react";
import { Box, Container, Typography, Grid, Paper } from "@mui/material";
import "./Interior.css";
import interiorBg from "../../assets/images/Interior1.jpg";
import { interiorServicesData } from "../../data/ServicesData";

export default function Interior() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Box className="interior-container">
      {/* Header Section */}
      <Box
        className="header-section"
        sx={{
          backgroundImage: `linear-gradient(rgba(255,255,255,0.9), rgba(255,255,255,0.9)), url(${interiorBg})`,
        }}
      >
        <Container>
          <Typography variant="h3" component="h1" className="header-title">
            Interior
          </Typography>
        </Container>
      </Box>

      <Container className="content-container">
        {/* Intro Section */}
        <Box className="intro-section">
          <Typography variant="h4" gutterBottom className="intro-title">
            Interior Design at VR Builders and Promoters
          </Typography>
          <Box
            sx={{
              width: "60px",
              height: "4px",
              backgroundColor: "#4285f4",
              margin: "0 auto 24px auto",
            }}
          />
          <Typography variant="body1" className="intro-text">
            At VR Builders and Promoters, we understand that interior design is
            more than just decoration—it's about creating spaces that reflect
            your personality, enhance your lifestyle, and function seamlessly
            for your everyday needs. Our team of experienced designers works
            closely with you to bring your vision to life, transforming your
            house into a home with welcoming environment. We create a unique
            atmosphere for your home by providing comprehensive interior design
            services that combine aesthetic appeal with practical functionality.
            From concept to completion, we handle every aspect of your interior
            design project with care and attention to detail.
          </Typography>
        </Box>

        <Grid container spacing={4} className="features-grid-container">
          {interiorServicesData.map((feature, index) => (
            <Grid item xs={12} md={6} lg={6} key={index}>
              <Paper elevation={0} className="feature-card">
                <Box className="feature-icon" sx={{ color: feature.iconColor }}>
                  {feature.icon}
                </Box>
                <Typography
                  variant="h6"
                  component="h3"
                  gutterBottom
                  className="feature-title"
                >
                  {feature.title}
                </Typography>
                <Typography variant="body2" className="feature-text">
                  {feature.text}
                </Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
